/**
 * This A11yUtils should only contains helpers,
 * manipulating Accessbility tree or its behaviours.
 * And it should not contains helpers, manipulating visual elements.
*/

/**
 *
 * @param {jQuery} $
 * @param {jQueryElement} selector
 * @param {string} filter
 * @returns jQueryElement
 */

function findAllFocusableElements ($, selector, filter = '') {
  return $(selector).find('a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]').not(filter);
}

/**
 *
 * @param {jQureyElement} $element
 * @returns jQueryElement
 */
function hideWithNoFocus ($element) {
  return $element.attr({
    'aria-hidden': true,
    tabindex: -1
  });
}

/**
 *
 * @param {jQureyElement} $element
 * @returns jQureyElement
 */
function showWithFocus ($element) {
  $element.attr({
    'aria-hidden': false,
    tabindex: 0
  }).get(0).focus();
  return $element;
}

/**
 *
 * @param {string|string[]} actionKeys
 * @param {jQureyElement} $element
 * @param {Function} callback
 */
function onKeyDown (actionKeys, $element, callback) {
  const keysMap = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    enter: 13,
    space: 32,
    esc: 27
  };
  function keydownEventListener (event, _this) {
    const key = event.keyCode;
    if (typeof actionKeys === 'string' && keysMap[actionKeys] === key) {
      callback(event, _this);
      event.preventDefault();
    } else if (actionKeys instanceof Array && actionKeys.reduce((acc, val) => acc || key === keysMap[val], false)) {
      callback(event, _this);
      event.preventDefault();
    }
  }
  $element.keydown(function (e) {
    keydownEventListener(e, this);
  });
}

/**
 *
 * @param {jQureyElement} $element
 * @param {Function} callback
 */
function buttonKeyboardSupport ($element, callback) {
  onKeyDown(['enter', 'space'], $element, callback);
}

export default {
  findAllFocusableElements,
  hideWithNoFocus,
  showWithFocus,
  onKeyDown,
  buttonKeyboardSupport
};
